// src/services/AuthService.js
import axios from 'axios';

class AuthService {
  constructor() {
    this.apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://api.your-backend.com';
    this.tokenKey = 'nft_marketplace_token';
    this.userKey = 'nft_marketplace_user';
    
    // Initialize axios with token if it exists
    this.setAuthHeader();
  }

  setAuthHeader() {
    const token = this.getToken();
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }

  getToken() {
    return localStorage.getItem(this.tokenKey);
  }

  getUser() {
    const userStr = localStorage.getItem(this.userKey);
    return userStr ? JSON.parse(userStr) : null;
  }

  setUserData(token, user) {
    localStorage.setItem(this.tokenKey, token);
    localStorage.setItem(this.userKey, JSON.stringify(user));
    this.setAuthHeader();
  }

  clearUserData() {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
    delete axios.defaults.headers.common['Authorization'];
  }

  async login(email, password) {
    try {
      const response = await axios.post(`${this.apiBaseUrl}/auth/login`, {
        email,
        password
      });
      
      const { token, user } = response.data;
      this.setUserData(token, user);
      return user;
    } catch (error) {
      console.error('Login error:', error);
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  }

  async register(userData) {
    try {
      const response = await axios.post(`${this.apiBaseUrl}/auth/register`, userData);
      
      const { token, user } = response.data;
      this.setUserData(token, user);
      return user;
    } catch (error) {
      console.error('Registration error:', error);
      throw new Error(error.response?.data?.message || 'Registration failed');
    }
  }

  logout() {
    this.clearUserData();
  }

  isAuthenticated() {
    return !!this.getToken();
  }
}

export default new AuthService();